import classNames from 'classnames';
import { FC } from 'react';
import { IS_TIGER_SELF } from 'utils/constants';
import { printf } from 'utils/i18n';
import style from './style.scss';

// 仅针对加盟商
const ComplianceReminder: FC = () => {
    if (IS_TIGER_SELF) {
        return null;
    }

    const disclosureLink = 'https://www.tradeup.com/agreement/224';

    return (
        <div className={classNames('compliance-reminder-root', style.root)}>
            <h4 className={style.title}>{__('Disclosures')}</h4>
            <p
                dangerouslySetInnerHTML={{
                    __html: printf(
                        __(
                            'Investment products and services are offered through TradeUP Securities, Inc. (TradeUP Securities), a member of <a href="%s" data-inapp-system target="_blank">FINRA</a> and <a href="%s" data-inapp-system target="_blank">SIPC</a>.'
                        ),
                        'https://www.finra.org/',
                        'https://www.sipc.org/'
                    )
                }}></p>
            <p>
                <a href={disclosureLink} title={__('disclosure')} data-inapp-blank className={style.link}>
                    {__('Read complete disclosure')} &nbsp;&gt;
                </a>
            </p>
            <div className={style.tips}>
                {__('INVESTMENT PRODUCTS ARE:')} <br />
                {__(
                    '・NOT FDIC INSURED・NOT INSURED BY ANY FEDERAL GOVERNMENT AGENCY・NOT A DEPOSIT OR OTHER OBLIGATION OF, OR GUARANTEED BY, BANKS・SUBJECT TO INVESTMENT RISKS, INCLUDING POSSIBLE LOSS OF THE PRINCIPAL AMOUNT INVESTED'
                )}
            </div>
        </div>
    );
};

export default ComplianceReminder;
